/* global ol */
export default {
  methods: {
    getDragResultRectStyle_() {
      return new ol.style.Style({
        fill: new ol.style.Fill({
          color: 'rgba(255, 255, 255, 0.2)',
        }),
        stroke: new ol.style.Stroke({
          color: 'rgba(0, 97, 255, 0.8)',
          width: 2,
        }),
      })
    },
    getDragResultRectFeature_(geom) {
      const feat = new ol.Feature({ geometry: geom })
      feat.setId('rect1')
      feat.setStyle(this.getDragResultRectStyle_())
      return feat
    },
    getDragBoxInteraction_(layer) {
      const dragBox = new ol.interaction.DragBox({
        condition: ol.events.condition.shiftKeyOnly
      })
      dragBox.on('boxstart', () => {
        layer.getSource().clear()
      })
      dragBox.on('boxend', () => {
        const extent = dragBox.getGeometry().getExtent()
        const feat = this.getDragResultRectFeature_(
          ol.geom.Polygon.fromExtent(extent))
        layer.getSource().addFeature(feat)
      })
      return dragBox
    },
    setDragResultRectFromCoords(coords) {
      // polygonだからもはやrectではないが...
      const layer = this.getLayer('dragBoxDraw')
      layer.getSource().clear()
      const feat = this.getDragResultRectFeature_(
        new ol.geom.Polygon(coords))
      layer.getSource().addFeature(feat)
    },
    getDragResultRectGeometry() {
      const layer = this.getLayer('dragBoxDraw')
      const src = layer.getSource()
      const feat = src.getFeatureById('rect1')
      if (!feat) { return null }
      return feat.getGeometry()
    },
    getDragBoxDrawLayer() {
      const layer = new ol.layer.Vector({
        source: new ol.source.Vector(),
      })
      layer.name = 'dragBoxDraw'
      layer.setZIndex = 9999

      const interaction = this.getDragBoxInteraction_(layer)
      return { layer, interaction }
    },
  }
}
